import { Message } from "primereact/message";

import { Dialog, DialogFooter, DialogHeader, Icon } from "@/ds";
import { RoleSummary } from "../role-summary";
import {
  DELETE_ROLE_DESCRIPTION,
  DELETE_ROLE_TITLE,
  DELETE_ROLE_WARNING,
} from "./delete-role-dialog.constants";
import styles from "./delete-role-dialog.module.scss";
import type { DeleteRoleDialogViewModel } from "./types-delete-role-dialog";

/** Pop-up Excluir Perfil (Figma 4663:284395): resumo do perfil, alerta MS001 e a confirmação em vermelho. */
export function DeleteRoleDialogView({
  role,
  isDeleting,
  confirmar,
  cancelar,
}: DeleteRoleDialogViewModel) {
  return (
    <Dialog
      visible
      className={styles.dialog}
      header={
        <DialogHeader
          icon="trash"
          tone="danger"
          title={DELETE_ROLE_TITLE}
          subtitle={DELETE_ROLE_DESCRIPTION}
        />
      }
      onHide={cancelar}
      locked={isDeleting}
      footer={
        <DialogFooter
          cancelVariant="outlined"
          cancelTestId="delete-role-cancel"
          confirmTestId="delete-role-confirm"
          confirmLabel={DELETE_ROLE_TITLE}
          severity="danger"
          loading={isDeleting}
          locked={isDeleting}
          onCancel={cancelar}
          onConfirm={confirmar}
        />
      }
      data-testid="delete-role-dialog"
    >
      <div className={styles.body}>
        <RoleSummary role={role} testId="delete-role-summary" />

        <Message
          severity="error"
          icon={<Icon name="exclamation-triangle" size={14} />}
          text={DELETE_ROLE_WARNING}
          role="alert"
          className="p-message-block p-message-sm"
          data-testid="delete-role-warning"
        />
      </div>
    </Dialog>
  );
}
